import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@gumtree/ui-library';
import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import { getClickListingDetails } from '@gumtree/shared/src/util/listing-details';

const TopSearchCondensed = ({ topSearchCondensed }) => (
    <ul className="link-list">
        {topSearchCondensed[0].items.map((el, index) => (
            <li className="item" key={el.name + index}>
                <Link
                    text={el.name}
                    dataQ="top-searches-link"
                    className="link"
                    href={el.url}
                    onClick={(e) => {
                        trackGA4AndNavigate({
                            href: el.url,
                            mouseEvent: e,
                            payload: {
                                event: 'link_click',
                                linkDomain: getLinkHostname(el.url),
                                linkText: el.name,
                                linkType: 'inside',
                                linkURL: el.url,
                                linkLocation: 'topSearches',
                                linkPosition: index + 1,
                                listLinkDetail: getClickListingDetails(),
                                linkDetail: {},
                            },
                        });
                    }}
                />
            </li>
        ))}
    </ul>
);

TopSearchCondensed.propTypes = {
    topSearchCondensed: PropTypes.array.isRequired,
};

export default TopSearchCondensed;
